import React, { memo, useCallback } from 'react';
import Modal from 'components/shared/Modal/Modal';
import ActionButton from '../ActionButton/ActionButton';
import styles from './ActionDialog.module.css';

const ActionDialog = ({
  onClose,
  height,
  width,
  title,
  message,
  fetching,
  hideCloseButton,
  isGlobal,
  actionHandler
}) => {
  const handleOnClick = useCallback(() => {
    if (!fetching && actionHandler) {
      actionHandler();
    }
  }, [fetching, actionHandler]);

  return (
    <Modal
      role="alertdialog"
      aria-labelledby="action_modal_title"
      aria-describedby="action_modal_message"
      animateX={false}
      close={onClose}
      noPadding
      height={height ?? 266}
      width={width ?? 480}
      hideCloseButton={hideCloseButton}
      global={isGlobal}
    >
      <div className={styles.container}>
        <div className={styles.topContainer}>
          <div id="action_modal_title" className={styles.headerText}>
            {title}
          </div>
          <div id="action_modal_message" className={styles.messageText}>
            {message}
          </div>
        </div>
        <div className={styles.bottomContainer}>
          {!hideCloseButton && (
            <button className={styles.cancelButton} onClick={onClose}>
              Close
            </button>
          )}
          {actionHandler && (
            <ActionButton
              title={'Confirm'}
              onClick={handleOnClick}
              disabled={fetching}
              customStyles={{ font: "400 14px 'Rubik'" }}
              backgroundColor={'var(--bermudaBlue)'}
              textColor={'var(--ibmsConsoleTileWhite)'}
              hoveredBackgroundColor={'var(--bermudaBlue-3'}
            />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default memo(ActionDialog);
